export default __webpack_public_path__ + "static/3-game-stage-ad6b0d15d5464b70e77f6517400058f2.jpg";